"use strict";
/**
 * Our own art, drawn on the 264×280 Avataaars canvas on top of the stock parts
 * (head centre 132,92; neck 108–156; torso from y≈200; the circle is centred
 * on 132,160 with radius 120).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HAT_BRIM_Y = void 0;
exports.headwearLayer = headwearLayer;
exports.clothingLayer = clothingLayer;
exports.propLayer = propLayer;
const PAINT_CHIPS = [
    ['f6c5c5', 'e58c8c', 'c95555'],
    ['cfe3d4', '8fbf9c', '4f8a5e'],
    ['d9e2f2', '9fb3d9', '5d7bb3'],
    ['f7e5c2', 'e8c47a', 'c9973a'],
];
const MEDAL_COLORS = {
    medalGold: ['f5c542', 'c9952a'],
    medalSilver: ['d5dbe1', '9aa5b1'],
    medalBronze: ['d7935a', 'a5673a'],
};
/** The hair is cut off above this line under a hat, so only what falls below the hat's front edge shows. */
exports.HAT_BRIM_Y = 56;
function headwearLayer(headwear, hatColor, bareHead) {
    switch (headwear) {
        case 'hat':
            // The stock Avataaars hat, drawn over the chosen hair instead of replacing it.
            return `<g transform="translate(-1)"><path d="M188.32 138.76C227.9 129.26 255 109.87 255 87.5c0-23.5-29.92-43.72-72.8-52.63l-.31-1.43A40 40 0 0 0 142.82 2h-18.64a40 40 0 0 0-39.07 31.44l-.27 1.21C41.41 43.45 11 63.8 11 87.5c0 22.37 27.1 41.76 66.68 51.26-.2-1.28-.36-2.58-.47-3.9A12 12 0 0 1 67 123v-13a12 12 0 0 1 10-11.83V92c0-8 1.68-15.62 4.7-22.51 8.61-15.69 92.73-16.49 102.66.16A55.82 55.82 0 0 1 189 92v6.17A12 12 0 0 1 199 110v13a12 12 0 0 1-10.2 11.87 56.06 56.06 0 0 1-.48 3.9Z" fill="#${hatColor}"/><path d="M189 92.74c3.85-3.25 6-6.9 6-10.74 0-6.08-5.38-11.65-14.32-15.98 1.64 1.1 2.9 2.3 3.68 3.63A55.82 55.82 0 0 1 189 92v.74ZM157.26 58.99a144.36 144.36 0 0 0-24.26-2c-8.98 0-17.52.78-25.22 2.17 15.16-2.2 34.11-2.3 49.48-.17ZM84.69 66.33C76.12 70.62 71 76.07 71 82c0 3.85 2.15 7.49 6 10.74V92c0-8 1.68-15.62 4.7-22.51a9.94 9.94 0 0 1 2.99-3.16Z" fill="#000" fill-opacity=".5"/></g>`;
        case 'kippah':
            return bareHead
                ? `<g>
        <path d="M97 52c3-12 18-20 35-20s32 8 35 20c-11-5-23-7-35-7s-24 2-35 7Z" fill="#${hatColor}"/>
        <path d="M97 52c11-5 23-7 35-7s24 2 35 7c-.4-1.6-1-3.2-1.7-4.700C154.5 43.2 143.5 41.5 132 41.500s-22.5 1.7-33.3 5.800c-.7 1.5-1.3 3.1-1.7 4.700Z" fill="#000" fill-opacity=".14"/>
      </g>`
                : `<g transform="translate(0 -4)">
        <path d="M98 50c3-17 18-28 34-28s31 11 34 28c-11-5-22-7-34-7s-23 2-34 7Z" fill="#${hatColor}"/>
        <path d="M98 50c11-5 22-7 34-7s23 2 34 7c-.4-2-.9-3.9-1.6-5.700C154 40.5 143 39 132 39s-22 1.5-32.4 5.300c-.7 1.8-1.2 3.7-1.6 5.700Z" fill="#000" fill-opacity=".14"/>
      </g>`;
        default:
            return '';
    }
}
function clothingLayer(clothing, clothesColor, accentColor) {
    switch (clothing) {
        case 'turtleneck':
            return `<g>
        <path d="M110 182h44a6 6 0 0 1 6 6l8 16c0 15-17 26-35.5 26S97 219 97 204l8-16a6 6 0 0 1 6-6Z" fill="#${clothesColor}"/>
        <path d="M110 182h44a6 6 0 0 1 6 6l1 4H103l1-4a6 6 0 0 1 6-6Z" fill="#000" fill-opacity=".14"/>
        <path d="M110 194v18M118 194v24M126 194v28M134 194v28M142 194v24M150 194v18" stroke="#000" stroke-opacity=".08" stroke-width="2"/>
      </g>`;
        case 'suit':
            return `<g>
        <path d="M99 197l33.5 29-17 13-12-16z" fill="#fff"/>
        <path d="M166 197l-33.5 29 17 13 12-16z" fill="#fff"/>
        <path d="M99 197l33.5 29-17 13-12-16z" fill="#000" fill-opacity=".05"/>
        <path d="M128 236h9l6 44h-21z" fill="#${accentColor}"/>
        <path d="M124 222h17l-4 14h-9z" fill="#${accentColor}"/>
        <path d="M128 236h9l1 5h-11z" fill="#000" fill-opacity=".18"/>
      </g>`;
        default:
            return '';
    }
}
function propLayer(prop, { propColor, variant, overTurtleneck }) {
    switch (prop) {
        case 'apron': {
            // The straps hang around the neck: the gap between them is the neck's width (the collar's, over a turtleneck).
            const [left, right] = overTurtleneck ? [98, 166] : [108, 156];
            return `<g>
        <path d="M${left - 17} 202l17-4 18 26h-16z" fill="#${propColor}"/>
        <path d="M${right + 17} 202l-17-4-18 26h16z" fill="#${propColor}"/>
        <path d="M${left - 17} 202l17-4 3.5 5-16.5 4zM${right + 17} 202l-17-4-3.5 5 16.5 4z" fill="#000" fill-opacity=".12"/>
        <path d="M110 222h44l16 58H92z" fill="#${propColor}"/>
        <path d="M105 246h54l1 4h-56z" fill="#000" fill-opacity=".1"/>
        <rect x="118" y="252" width="28" height="18" rx="3" fill="#000" fill-opacity=".12"/>
        <path d="M110 222h44l1 4h-46z" fill="#fff" fill-opacity=".18"/>
      </g>`;
        }
        case 'scarf':
            return overTurtleneck
                ? `<g>
        <path d="M150 220l14 40h-20l-8-40z" fill="#${propColor}"/>
        <path d="M150 220l14 40h-20l-8-40z" fill="#000" fill-opacity=".12"/>
        <path d="M148 252h16M146 246h18" stroke="#000" stroke-opacity=".12" stroke-width="2"/>
        <path d="M95 196c10 14 65 14 75 0v18c-10 14-65 14-75 0z" fill="#${propColor}"/>
        <path d="M95 205c10 14 65 14 75 0v4c-10 14-65 14-75 0z" fill="#000" fill-opacity=".12"/>
        <path d="M95 196c10 14 65 14 75 0v3c-10 14-65 14-75 0z" fill="#fff" fill-opacity=".18"/>
      </g>`
                : `<g>
        <path d="M144 206l12 44h-19l-7-44z" fill="#${propColor}"/>
        <path d="M144 206l12 44h-19l-7-44z" fill="#000" fill-opacity=".12"/>
        <path d="M141 242h15M139 236h16" stroke="#000" stroke-opacity=".12" stroke-width="2"/>
        <path d="M104 182c8 10 48 10 56 0v20c-8 10-48 10-56 0z" fill="#${propColor}"/>
        <path d="M104 192c8 10 48 10 56 0v4c-8 10-48 10-56 0z" fill="#000" fill-opacity=".12"/>
        <path d="M104 182c8 10 48 10 56 0v3c-8 10-48 10-56 0z" fill="#fff" fill-opacity=".18"/>
      </g>`;
        case 'swatches':
            return `<g transform="translate(200 276)">
        <rect x="-11" y="-84" width="22" height="78" rx="4" fill="#3f5a7a" transform="rotate(-66)"/>
        <rect x="-11" y="-84" width="22" height="78" rx="4" fill="#8aa77b" transform="rotate(-46)"/>
        <rect x="-11" y="-84" width="22" height="78" rx="4" fill="#e2b04a" transform="rotate(-26)"/>
        <rect x="-11" y="-84" width="22" height="78" rx="4" fill="#c76b4a" transform="rotate(-6)"/>
        <rect x="-11" y="-84" width="22" height="78" rx="4" fill="#000" fill-opacity=".08" transform="rotate(-6)"/>
        <circle r="7" fill="#fff" stroke="#8d8d8d" stroke-width="3"/>
      </g>`;
        case 'paintChip': {
            const chip = PAINT_CHIPS[variant % PAINT_CHIPS.length];
            return `<g transform="rotate(10 190 250)">
        <rect x="166" y="212" width="48" height="76" rx="4" fill="#fff"/>
        <rect x="171" y="217" width="38" height="22" fill="#${chip[0]}"/>
        <rect x="171" y="239" width="38" height="22" fill="#${chip[1]}"/>
        <rect x="171" y="261" width="38" height="22" fill="#${chip[2]}"/>
        <rect x="166" y="212" width="48" height="76" rx="4" fill="#000" fill-opacity=".06"/>
      </g>`;
        }
        case 'camera':
            return `<g transform="translate(-44 -53) scale(1.18) rotate(8 190 252)">
        <path d="M150 204c10 16 20 26 30 30l-5 5c-11-5-22-16-31-31Z" fill="#3b3b3b"/>
        <rect x="174" y="226" width="20" height="10" rx="3" fill="#262e33"/>
        <rect x="160" y="232" width="58" height="42" rx="7" fill="#3b3b3b"/>
        <rect x="160" y="240" width="58" height="8" fill="#c9a27e"/>
        <circle cx="189" cy="254" r="15" fill="#929598"/>
        <circle cx="189" cy="254" r="11" fill="#262e33"/>
        <circle cx="189" cy="254" r="6" fill="#3f5a7a"/>
        <circle cx="185.5" cy="250.5" r="2.5" fill="#fff" fill-opacity=".7"/>
        <rect x="204" y="228" width="9" height="5" rx="2" fill="#c76b4a"/>
        <rect x="160" y="232" width="58" height="42" rx="7" fill="#000" fill-opacity=".06"/>
      </g>`;
        case 'coffeeMug':
            return `<g transform="translate(-48 -53) scale(1.18) rotate(6 190 252)">
        <path d="M212 244c18 0 18 26 0 26" fill="none" stroke="#a85638" stroke-width="7" stroke-linecap="round"/>
        <path d="M164 234h50v36a10 10 0 0 1-10 10h-30a10 10 0 0 1-10-10z" fill="#c76b4a"/>
        <path d="M164 246h50v6h-50z" fill="#000" fill-opacity=".1"/>
        <path d="M170 242h6v28a3 3 0 0 1-6 0z" fill="#fff" fill-opacity=".22"/>
        <ellipse cx="189" cy="234" rx="25" ry="5" fill="#a85638"/>
        <ellipse cx="189" cy="234.5" rx="21" ry="3.5" fill="#5a4636"/>
        <path d="M181 224c-4-6 4-8 0-14M195 226c-4-6 4-8 0-14" fill="none" stroke="#fff" stroke-opacity=".8" stroke-width="2.5" stroke-linecap="round"/>
      </g>`;
        case 'medalGold':
        case 'medalSilver':
        case 'medalBronze': {
            const [fill, edge] = MEDAL_COLORS[prop];
            // The ribbon hangs around the neck: the gap between its bands is the neck's width (the collar's, over a turtleneck).
            const [left, right] = overTurtleneck ? [98, 166] : [108, 156];
            return `<g>
        <path d="M${left - 22} 203l22-5L141 236h-18z" fill="#3f5a7a"/>
        <path d="M${right + 22} 203l-22-5L123 236h18z" fill="#4f6f95"/>
        <path d="M${left - 14} 201.2l7-1.6L135 236h-6zM${right + 14} 201.2l-7-1.6L129 236h6z" fill="#fff" fill-opacity=".55"/>
        <rect x="125" y="231" width="14" height="6" rx="2" fill="#${edge}"/>
        <circle cx="132" cy="251" r="17" fill="#${edge}"/>
        <circle cx="132" cy="251" r="14" fill="#${fill}"/>
        <path d="M132 243l1.9 5.4 5.7.1-4.6 3.5 1.7 5.5-4.7-3.3-4.7 3.3 1.7-5.5-4.6-3.5 5.7-.1z" fill="#fff" fill-opacity=".75"/>
      </g>`;
        }
        default:
            return '';
    }
}
